<template>
  <div class="main-box">
    <h1>Gebäude erstellen</h1>
    <div class="my-2">
      <b-button to="/gebaeude">Zurück</b-button>
    </div>

    <b-alert v-model="hasUnknownError" variant="danger">
      {{ unknownErrorMessage }}
    </b-alert>

    <b-alert v-model="hasError" variant="warning">
      {{ errorMessage }}
    </b-alert>

    <type-ahead :form="form" />

    <validation-observer ref="observer" v-slot="{ passes }" v-if="isFormVisible">
      <b-form @submit.prevent="passes(onSubmit)">
        <property-add :form="form" />
        <b-button type="submit" variant="primary" disabled v-if="isSubmitting">
          <b-spinner small></b-spinner>
          Gebäude erfassen
        </b-button>
        <b-button type="submit" variant="primary" v-else>Gebäude erfassen</b-button>
      </b-form>
    </validation-observer>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import { ValidationObserver } from 'vee-validate'
  import { errorHandler } from '@/helpers/formHelper.js'
  import PropertyAdd from '@/components/property/PropertyAdd.vue'
  import TypeAhead from '@/components/property/TypeAhead.vue'

  const getInitialData = () => ({
    form: {
      strasse: '',
      hausNr: '',
      plz: '',
      ort: '',
      egid: '',
      versicherungsNr: '',
      parzellenNr: '',
      gebaeudeart: 80,
      nutzung: 29,
      baujahr: null,
      anzahlWohnungen: null,
      energiebezugsflaeche: null,
      hauptwaermeerzeugungBestehend: 173,
      hauptwaermeerzeugungBestehendAndere: '',
      hauptwaermeerzeugungNeu: 173,
      denkmalgeschuetzt: false,
      gemeindeId: null
    }
  })

  export default {
    components: {
      ValidationObserver,
      PropertyAdd,
      TypeAhead
    },
    data: () => ({
      isSubmitting: false,
      hasUnknownError: false,
      unknownErrorMessage: '',
      hasError: false,
      errorMessage: '',
      ...getInitialData()
    }),
    methods: {
      scrollTo () {
        this.$scrollTo('.logo')
      },
      onSubmit () {
        this.isSubmitting = true
        this.hasUnknownError = false
        this.hasError = false

        this.$store.dispatch('property/SAVE_PROPERTY', this.form).then(res => {
          const { data, errors } = res

          if (errors) {
            this.isSubmitting = false
            this.scrollTo()
            return errorHandler(this, errors)
          }

          const { gemeindeId: communityId } = data.liegenschaftCreate

          if (!communityId) {
            this.isSubmitting = false
            this.hasError = true
            this.errorMessage = 'Für das Gebäude wurde keine St.Galler Gemeinde erkannt'
          }

          this.isSubmitting = false
          this.$router.push({ name: 'property' }).catch((e) => {})
        }).catch(err => {
          this.isSubmitting = false
          this.hasUnknownError = true
          this.unknownErrorMessage = this.$t('formError.unknownwError')
          this.scrollTo()
          console.error(err)
        })
      },
      reset () {
        Object.assign(this.$data, getInitialData())
        requestAnimationFrame(() => {
          this.$refs.observer.reset()
        })
      }
    },
    computed: {
      ...mapState({
        isFormVisible: state => state.property.propertyAdd.isFormVisible
      })
    }
  }
</script>

<style lang="scss" scoped>
  .optional{
    text-decoration: underline;
  }
</style>
